import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";

// Request types
interface RequestCodeRequest {
  email: string;
}

interface RequestCodeResponse {
  status: string;
  message: string;
}

interface VerifyCodeRequest {
  email: string;
  code: string;
}

interface VerifyCodeResponse {
  status: string;
}

// Request a verification code (magic link)
// POST /auth/free/request
export function useRequestCode() {
  return useMutation<RequestCodeResponse, Error, RequestCodeRequest>({
    mutationFn: (data) =>
      apiFetch<RequestCodeResponse>("/auth/free/request", {
        method: "POST",
        body: JSON.stringify(data),
      }),
  });
}

// Verify code and authenticate
// POST /auth/free/verify
export function useVerifyCode() {
  return useMutation<VerifyCodeResponse, Error, VerifyCodeRequest>({
    mutationFn: (data) =>
      apiFetch<VerifyCodeResponse>("/auth/free/verify", {
        method: "POST",
        body: JSON.stringify(data),
      }),
  });
}
